import { FC, ReactNode } from 'react';

import classNames from 'classnames';

import { Typography } from '../../../typography/components/Typography/Typography';

interface Props {
   align?: 'left' | 'center' | 'right';
   colSpan?: number;
   rowSpan?: number;
   scope?: 'col' | 'row';
   width?: string;
   height?: string;
   minWidth?: string;
   whiteSpace?: 'normal' | 'nowrap';
   paddingX?: 'sm' | 'md' | 'lg';
   /** When true, renders children directly without Typography wrapper */
   raw?: boolean;
   onClick?: () => void;
   children: ReactNode;
}

const paddingMap = {
   sm: 'px-component-layout-box-spacing-padding-edge-to-text-horizontal-sm',
   md: 'px-component-layout-box-spacing-padding-edge-to-text-horizontal-md',
   lg: 'px-component-layout-box-spacing-padding-edge-to-text-horizontal-lg'
};

export const TableHeader: FC<Props> = ({ align = 'left', colSpan = 1, rowSpan = 1, scope = 'col', children, onClick, width, height, minWidth, whiteSpace, paddingX = 'lg', raw = false }) => (
   <th
      data-testid="table-header"
      align={align}
      colSpan={colSpan}
      rowSpan={rowSpan}
      scope={scope}
      onClick={onClick}
      className={classNames(paddingMap[paddingX], 'py-component-layout-box-spacing-padding-edge-to-element-vertical-lg snap-start', {
         'whitespace-nowrap': whiteSpace === 'nowrap',
         'whitespace-normal': whiteSpace === 'normal'
      })}
      style={{ width, height, minWidth }}
   >
      {raw ? (
         children
      ) : (
         <Typography variant="body-highlight" color="strong">
            {children}
         </Typography>
      )}
   </th>
);
